import { useState } from 'react'
import { getViewType, setViewType, type ViewType } from '@/core/lib/viewTypePrefs'

export function useViewTypePref(): [ViewType, (v: ViewType) => void] {
  const [type, setType] = useState<ViewType>(getViewType)
  const set = (v: ViewType) => {
    setType(v)
    setViewType(v)
  }
  return [type, set]
}
